import * as e from "react";
import { c as o } from "../createReactComponent-58f9bea8.mjs";
import { b as r, r as t } from "../checkbox-46b40c6a.mjs";
import { C, a as b } from "../checkbox-46b40c6a.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
import "../icon-c572aa57.mjs";
const i = o({ tagName: "ex-checkbox", elementClass: r, react: e, events: { onChange: "on-change" }, displayName: "ExCheckbox", registerWebComponent: t });
export {
  C as CheckboxFooterType,
  b as CheckboxSize,
  i as ExCheckbox,
  t as register
};
